import { IDateQuestion } from '../../../../../types/builder.types';

export const REQUIRED_QUESTION_ERROR_MESSAGE = '* This question is required';
export const USER_REQUIRED_SIGNATURE_ERROR_MESSAGE =
    'To continue, you need to sign the contract.';
export const dateOrderError = ({
    start_date_text,
    end_date_text
}: IDateQuestion) =>
    `${start_date_text || 'Start date'} should be earlier than ${
        end_date_text || 'end date'
    }`;
export const REQUIRED_CHARGE_BLOCK_ERROR_MESSAGE =
    'Payment is required in order to continue.';

export const invoiceDeleteDisabledMessage = (isPage: boolean) => {
    return `You can't delete ${
        isPage ? 'a page with an ' : 'an'
    } invoice/payment  if your client has already completed a payment. 
    To cancel upcoming payments, hover over a payment & delete. 
    Clients won't see the payment screen if there are no future payments.`;
};

export const contractDeleteDisabledMessage = (isPage: boolean) => {
    return `You can't delete ${
        isPage ? 'a page with a ' : 'a'
    } contract that is already signed by a client `;
};
